import { render, staticRenderFns } from "./other-party-tab.vue?vue&type=template&id=50169e07&scoped=true"
import script from "./other-party-tab.vue?vue&type=script&lang=js"
export * from "./other-party-tab.vue?vue&type=script&lang=js"
import style0 from "./other-party-tab.vue?vue&type=style&index=0&id=50169e07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50169e07",
  null
  
)

export default component.exports